import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const faqs = [
  {
    question: "What exactly is the MERN stack?",
    answer: "MERN stands for MongoDB, Express.js, React, and Node.js. It's a full-stack JavaScript framework that we use to build fast, robust, and highly scalable web applications."
  },
  {
    question: "Do you offer mobile app development?",
    answer: "Yes, we specialize in both native iOS & Android apps as well as cross-platform solutions using tools like React Native to deliver excellent mobile experiences."
  },
  {
    question: "How long does a typical project take?",
    answer: "Project timelines vary widely depending on complexity. A standard business website might take 2-4 weeks, while a complex custom web application could take 3-6 months. We will provide a detailed timeline during scoping."
  },
  {
    question: "Do you provide post-launch support and maintenance?",
    answer: "Absolutely. We view our client relationships as long-term partnerships. We offer ongoing maintenance, security updates, and feature enhancement retainers after your project launches."
  },
  {
    question: "How do you handle project communication?",
    answer: "We ensure complete transparency throughout the development cycle. We use modern tools like Slack, Jira, and GitHub, and hold regular sync-up meetings to keep you updated on progress."
  }
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="min-h-screen pt-32 pb-20 px-6" style={{ background: 'var(--bg-primary)' }}>
      <div className="max-w-3xl mx-auto">
        
        <div className="text-center mb-16 anim-hidden anim-visible">
          <p className="eyebrow mb-4">Support</p>
          <h1 className="display-md mb-4" style={{ color: 'var(--text-primary)' }}>
            Frequently Asked <span className="gradient-text">Questions</span>
          </h1>
          <p className="subheadline">Everything you need to know about our services and processes.</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`rounded-2xl transition-all duration-300 overflow-hidden
                          ${openIndex === index ? 'shadow-lg shadow-accent/5' : 'hover:border-gray-300'}`}
              style={{
                background: 'var(--bg-card)',
                border: openIndex === index ? '1px solid var(--accent)' : '1px solid var(--border-color)'
              }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full text-left px-6 py-6 flex items-center justify-between gap-4 focus:outline-none"
              >
                <span className={`text-base font-bold tracking-tight transition-colors
                                 ${openIndex === index ? '' : ''}`}
                      style={{ color: openIndex === index ? 'var(--accent)' : 'var(--text-primary)' }}>
                  {faq.question}
                </span>
                <FaChevronDown 
                  className={`transition-transform duration-300 
                             ${openIndex === index ? 'rotate-180' : ''}`} 
                  size={14} 
                  style={{ color: openIndex === index ? 'var(--accent)' : 'var(--text-tertiary)' }}
                />
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ease-in-out
                            ${openIndex === index ? 'max-h-64 pb-6 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
